import { ReactComponent as ClaudeDesktopIcon } from 'Images/claude_desktop.svg';

import { PLACEHOLDER } from './placeholders';
import {
  AUTH_TOKEN,
  AUTH_USER_PASSWORD,
  BLOCK_FILE,
  BLOCK_NOTE,
  BLOCK_PATHS,
  CLIENT_STATUS_SUPPORTED
} from './constants';

const buildArgs = (authMethod) => {
  const credentials = authMethod === AUTH_USER_PASSWORD
    ? [
      `"--header", "X-Faraday-Username:${PLACEHOLDER.username}",`,
      `"--header", "X-Faraday-Password:${PLACEHOLDER.password}"`
      ]
    : [`"--header", "X-Faraday-Token:${PLACEHOLDER.apiToken}"`];

  return [
    '"-y", "mcp-remote",',
    `"${PLACEHOLDER.serverUrl}",`,
    `"--header", "X-Faraday-URL:${PLACEHOLDER.instanceUrl}",`,
    ...credentials
  ].map((line) => `        ${line}`).join('\n');
};

const buildConfig = (authMethod) => `{
  "mcpServers": {
    "faraday": {
      "command": "npx",
      "args": [
${buildArgs(authMethod)}
      ]
    }
  }
}`;

const claudeDesktop = {
  id: 'claudeDesktop',
  label: 'Claude Desktop',
  icon: ClaudeDesktopIcon,
  status: CLIENT_STATUS_SUPPORTED,
  authMethods: [AUTH_TOKEN, AUTH_USER_PASSWORD],
  summaryId: 'mcp.client.claudeDesktop.summary',
  buildSections: ({ authMethod }) => [
    {
      id: 'requirements',
      titleId: 'mcp.client.claudeDesktop.requirements.title',
      blocks: [
        {
          id: 'node',
          type: BLOCK_NOTE,
          textId: 'mcp.client.claudeDesktop.requirements.node'
        }
      ]
    },
    {
      id: 'config',
      titleId: 'mcp.client.claudeDesktop.config.title',
      blocks: [
        {
          id: 'config-file',
          type: BLOCK_FILE,
          captionId: 'mcp.client.claudeDesktop.config.caption',
          snippet: buildConfig(authMethod)
        },
        {
          id: 'header-format',
          type: BLOCK_NOTE,
          textId: 'mcp.client.claudeDesktop.config.headerFormat'
        }
      ]
    },
    {
      id: 'locations',
      titleId: 'mcp.client.claudeDesktop.locations.title',
      blocks: [
        {
          id: 'paths',
          type: BLOCK_PATHS,
          items: [
            {
              id: 'macOS',
              labelId: 'mcp.os.macOS',
              value: '~/Library/Application Support/Claude/claude_desktop_config.json'
            },
            {
              id: 'windows',
              labelId: 'mcp.os.windows',
              value: '%APPDATA%\\Claude\\claude_desktop_config.json'
            },
            {
              id: 'linux',
              labelId: 'mcp.os.linux',
              value: '~/.config/Claude/claude_desktop_config.json'
            }
          ]
        },
        {
          id: 'restart',
          type: BLOCK_NOTE,
          textId: 'mcp.client.claudeDesktop.restart'
        }
      ]
    }
  ]
};

export default claudeDesktop;
